import { Component, input } from '@angular/core';

/**
 * TabComponent represents a single tab that can be part of a TabsComponent.
 * It displays its content based on the tab's active state and pre-rendering configuration.
 */
@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [],
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
})
export class TabComponent {
  /**
   * Title of the tab.
   */
  public readonly tabTitle = input<string>('');

  /**
   * Flag to determine if the tab should be pre-rendered.
   */
  public readonly shouldPreRender = input<boolean>(false);

  /**
   * Indicates whether the tab is currently active.
   */
  public isActive: boolean = false;
}
